import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import {
  Card,
  CardActionArea,
  CardContent,
  Tooltip,
  Fab,
  Grid,
} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import AddIcon from "@material-ui/icons/Add";
import { CarrouselCertificados } from "../carrousel/CarrouselCertificados";
import CarrouselMini from "../carrouselChico/CarrouselMini";
import { startUploading } from "../../actions/certificados";

const useStyles = makeStyles({
  root: {
    maxWidth: 345,
  },
  colorAdd: {
    backgroundColor: "#21b6ae",
  },
  colorTrash: {
    backgroundColor: "#ff334f",
  },
  cardStyle: {
    display: "block",
    width: 200,
    transitionDuration: "0.3s",
    height: "auto",
  },
  title: {
    fontSize: 10,
    marginLeft: 10,
  },
  btnoculto: {
    backgroundColor: "Transparent",
    backgroundRepeat: "no-repeat",
    border: "none",
    cursor: "pointer",
    overflow: "hidden",
    outline: "none",
    height: "100%",
    width: "100%",
  },
});

export const TarjetaCertificado = React.memo(({ urls, titulo, idItem, esPreAfiliacion, idPreAfiliado }) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const [mostrarcarrousel, setMostrarcarrousel] = useState(false);

  const handleAddClick = (e) => {
    document.querySelector(`#fileSelectorCert${idItem}`).click();
  };

  const handleFileChange = (e) => {
    dispatch(startUploading(e.target.files[0], idItem, esPreAfiliacion));
  };

  return (
    <>
      <input
        id={`fileSelectorCert${idItem}`}
        type="file"
        accept="image/jpeg,image/jpg,image/png,application/pdf"
        onChange={handleFileChange}
        style={{ display: "none" }}
      />
      <Card className={classes.cardStyle}>
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="center"
        >
          <Typography
            className={classes.title}
            color="textSecondary"
            gutterBottom
          >
            {`${titulo} (${!!urls ? urls.length : 0})`}
          </Typography>
          {(idItem && urls.length < 1) &&
            <Tooltip title="Incorporar" aria-label="add">
              <Fab
                size="small"
                color="primary"
                onClick={handleAddClick}
                className={classes.colorAdd}
              >
                <AddIcon />
              </Fab>
            </Tooltip>
          }
        </Grid>
        <CardActionArea>
          <CardContent>
            {
              urls
                ?
                <Grid
                  container
                  direction="row"
                  justify="space-between"
                  alignItems="center"
                >
                  {" "}
                  <div
                    className={classes.btnoculto}
                    onClick={() => {
                      setMostrarcarrousel(!mostrarcarrousel);
                    }}
                  >
                    <CarrouselMini idTipoDocumentacion={idItem} urls={urls} />
                    <CarrouselCertificados
                      urls={urls}
                      idCertificado={idItem}
                      mostrar={mostrarcarrousel}
                      titulo={titulo}
                      setMostrar={setMostrarcarrousel}
                      esPreAfiliacion={esPreAfiliacion}
                      idPreAfiliado={idPreAfiliado}
                    />
                  </div>
                </Grid>
                :
                <Typography
                  className={classes.title}
                  color="textPrimary"
                  gutterBottom
                >
                  Sin Certificado
                </Typography>
            }
          </CardContent>
        </CardActionArea>
      </Card>
    </>
  );
}
);
